import React from 'react';
import Header from '../components/Header/header';
import publications from '../images/covers/publications.jpg';
import Publication from "../components/Publication/publication";

export default ({ data }) => {

    return (
    <div className="team">
      <Header
        image={publications}
        title={"NANOTECH LAB | YUSHIN GROUP"}
        subtitle={"Publications"}
      />
        <section className={"google-scholar"}>
            <div className={"container"}>
                <div className="row">
                    <p className="col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10">
                        The Yushin Group leads six main areas of interest for energy storage: conversion electrodes,
                        selective metal dealloying, aqueous-ion storage devices, nanocomposite materials, multifunctional electrodes,
                        and solid-state electrolytes/batteries. For a complete listing of publications,
                        please visit <a href="https://scholar.google.com/citations?user=TwX62mwAAAAJ&hl=en">Google Scholar.</a>
                    </p>
                </div>
            </div>
        </section>
      <div className={"container publications"}>
        <div className={"row"} style={{marginTop: "24px"}}>
          {
            data.allContentfulPublication.edges.map(( { node } ) => {
              return <Publication key={node.id} title={node.title} journal={node.journal} authors={node.authors} year={node.year} abstract={node.description.description} link={node.url}/>
            })
          }
        </div>
      </div>

    </div>
  );
};

export const query = graphql`
  query PublicationQuery {
    allContentfulPublication (sort: {fields: [year], order:DESC}){
      edges{
        node {
            id
            title
            journal
            year
            authors
            description {
              id
              description
            }
            url
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/publications.js